// extracted by css-extract-rspack-plugin
module.exports =  {"root":"FormSection__root___v9I3y","label":"FormSection__label___JGCPo","box":"FormSection__box___g5fFS","edgeToEdge":"FormSection__edgeToEdge___Kc3rk"};